import {
    getApiErrorMessage,
    getFormMode,
    getRecordFromResponse,
    getResponseData,
    MULTIPART_CONFIG
} from 'lib/formUtils';
import {
    appendFieldsToFormData,
    formatData,
    formatTime,
    getDateInputValue,
    getOnlyDigits
} from 'lib/functions';
import {
    Box,
    Button,
    Card,
    CardContent,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    FormGroup,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    Typography
} from '@material-ui/core';
import {
    CloudUploadOutlined,
    FeedbackOutlined,
    PictureAsPdfRounded
} from '@material-ui/icons';
import theme from 'theme';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { isFlagAtiva } from 'lib/configUtils';
import { safeSetState } from 'lib/reactUtils';
import { ImagePreviewModal } from 'views/Components';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { handleEnabledIconMouseEnter, handleEnabledIconMouseLeave } from 'lib/uiUtils';

class AgendaEscalaFornecedorForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        escala: null,
        itens: [],
        isLoading: true,
        isGeneratingReport: false,
        isView: false,
        configPartner: {},
        kminicial: '',
        kmfinal: '',
        fotoKmInicial: null,
        fotoKmFinal: null,
        fotoKmInicialPreview: '',
        fotoKmFinalPreview: '',
        isImageModalOpen: false,
        imageModalSrc: '',
        imageModalAlt: '',
        openAlert: false,
        messageAlert: '',
        openObsModal: false,
        obsModalTexto: '',
        obsModalTitulo: '',
        openPaxModal: false,
        paxModalTitulo: '',
        paxModalTotal: 0,
        paxModalItens: [],
        paxModalGeral: false
    };

    /* Eventos do ícone de relatório */
    // ao passar o cursor
    handleReportIconMouseEnter = (event) => {
        const { isGeneratingReport } = this.state;

        handleEnabledIconMouseEnter(event, isGeneratingReport);
    };

    // ao remover o cursor
    handleReportIconMouseLeave = (event) => {
        const { isGeneratingReport } = this.state;

        handleEnabledIconMouseLeave(event, isGeneratingReport);
    };

    /* Abre o modal de observação */
    handleObsIconClick = (item, disabled) => {
        if (disabled) {
            return;
        }

        this.handleOpenObsModal(item);
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            await this.loadAgendaEscalaFornecedor(id, isView);
        } catch (error) {
            console.error(
                'Erro ao carregar agenda de escala do fornecedor:',
                error.response?.data || error.message
            );

            this.safeSetState({
                escala: null,
                itens: [],
                isLoading: false
            });

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar detalhes da escala!'
                )
            );
        }
    };

    /* Libera as URLs temporárias das fotos */
    componentWillUnmount() {
        this._isMounted = false;

        const { fotoKmInicialPreview, fotoKmFinalPreview } = this.state;

        if (fotoKmInicialPreview) {
            URL.revokeObjectURL(fotoKmInicialPreview);
        }

        if (fotoKmFinalPreview) {
            URL.revokeObjectURL(fotoKmFinalPreview);
        }
    };

    /* Carrega a agenda de escalas do fornecedor */
    loadAgendaEscalaFornecedor = async (id, isView) => {
        const responseEscala = await api.get(`/agendaescalafornecedor/${id}`);
        const configPartnerRaw = responseEscala?.data?.configPartner || {};
        const escala = getRecordFromResponse(responseEscala);

        const configPartner = Object.fromEntries(
            Object.entries(configPartnerRaw).map(([key, value]) => [
                key,
                typeof value === 'string' ? value.trim() : value
            ])
        );

        const responseItens = await api.get(`/agendaescalafornecedor/${id}/itens`);
        const itens = getResponseData(responseItens);

        this.safeSetState({
            escala,
            itens,
            isLoading: false,
            isView,
            configPartner,
            kminicial: escala?.kminicial != null ? String(escala.kminicial) : '',
            kmfinal: escala?.kmfinal != null ? String(escala.kmfinal) : ''
        });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({
            openAlert: false
        });
    };

    /* Retorna o payload de agenda de escala do fornecedor */
    getPayloadAgendaEscalaFornecedor = () => {
        const { kminicial, fotoKmInicial, kmfinal, fotoKmFinal } = this.state;

        const formData = appendFieldsToFormData({
            kminicial: kminicial || '',
            kmfinal: kmfinal || ''
        });

        if (fotoKmInicial) {
            formData.append('fotokminicial', fotoKmInicial);
        }

        if (fotoKmFinal) {
            formData.append('fotokmfinal', fotoKmFinal);
        }

        return formData;
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { escala, kminicial, kmfinal } = this.state;
        const { history } = this.props;

        const coditemescala = Number(escala?.coditemescala);

        if (!Number.isInteger(coditemescala) || coditemescala <= 0) {
            this.handleOpenAlert('O item da escala é inválido!');

            return;
        }

        if ((kminicial && !kmfinal) || (!kminicial && kmfinal)) {
            this.handleOpenAlert('Obrigatório informar o KM inicial e o KM final para salvar!');

            return;
        }

        if (kminicial && kmfinal && Number(kmfinal) <= Number(kminicial)) {
            this.handleOpenAlert('KM final deve ser maior que o KM inicial!');

            return;
        }

        try {
            const formData = this.getPayloadAgendaEscalaFornecedor();

            await api.put(
                `/agendaescalafornecedor/${escala.coditemescala}`,
                formData,
                MULTIPART_CONFIG
            );

            history.push(this.getBaseRoute());
        } catch (error) {
            console.error(
                'Erro ao salvar:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Converte uma resposta blob de erro em mensagem */
    getBlobErrorMessage = async (blob, defaultMessage) => {
        try {
            const blobText = await blob.text();

            if (!blobText) {
                return defaultMessage;
            }

            try {
                const parsedMessage = JSON.parse(blobText);

                return (
                    parsedMessage.error ||
                    parsedMessage.message ||
                    parsedMessage.mensagem ||
                    defaultMessage
                );
            } catch (jsonError) {
                return blobText;
            }
        } catch (error) {
            return defaultMessage;
        }
    };

    /* Gera e baixa o relatório da escala */
    onClickGenerateReport = async () => {
        const { escala, isGeneratingReport } = this.state;
        const coditemescala = Number(escala?.coditemescala);

        if (isGeneratingReport || !Number.isInteger(coditemescala) || coditemescala <= 0) {
            return;
        }

        try {
            this.setState({ isGeneratingReport: true });

            const response = await api.post(
                '/partner/generate-report',
                { coditemescala },
                {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/pdf'
                    }
                }
            );

            const contentType = response?.headers?.['content-type'] || 'application/pdf';

            // caso o backend retorne JSON ou texto em uma situação de erro, evita baixar como PDF
            if (contentType.includes('json') || contentType.includes('text/')) {
                const message = await this.getBlobErrorMessage(
                    response.data,
                    'Não foi possível gerar o relatório!'
                );

                throw new Error(message);
            }

            const blob = new Blob(
                [response.data],
                { type: contentType }
            );

            if (!blob.size) {
                throw new Error('O relatório retornado pela API está vazio!');
            }

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = `relatorio_transporte_${coditemescala}.pdf`;
            link.style.display = 'none';

            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                link.remove();
                window.URL.revokeObjectURL(url);
            }, 1000);
        } catch (error) {
            console.error(
                'Não foi possível gerar o relatório de transporte:',
                error.response?.data || error
            );

            let message = 'Não foi possível gerar o relatório de transporte!';

            if (error.response?.data instanceof Blob) {
                message = await this.getBlobErrorMessage(
                    error.response.data,
                    message
                );
            } else {
                message = getApiErrorMessage(
                    error,
                    message
                );
            }

            this.handleOpenAlert(message);
        } finally {
            this.setState({ isGeneratingReport: false });
        }
    };

    /* Clicar para voltar */
    onClickVoltar = () => {
        this.props.history.push(this.getBaseRoute());
    };

    /* Altera os campos de KM */
    handleKmChange = (event) => {
        const { name, value } = event.target;

        this.setState({ [name]: getOnlyDigits(value) });
    };

    /* Seleciona a foto do KM */
    handleFotoChange = (event) => {
        const { files, name } = event.target;
        const file = files?.[0];

        if (!file) {
            return;
        }

        const previewField = name === 'fotoKmInicial' ? 'fotoKmInicialPreview' : 'fotoKmFinalPreview';
        const currentPreview = this.state[previewField];

        if (currentPreview) {
            URL.revokeObjectURL(currentPreview);
        }

        this.setState({
            [name]: file,
            [previewField]: URL.createObjectURL(file)
        });
    };

    /* Abre o modal de visualização da foto */
    handleOpenImageModal = (src, alt) => {
        if (!src) {
            return;
        }

        this.setState({
            isImageModalOpen: true,
            imageModalSrc: src,
            imageModalAlt: alt || 'Imagem'
        });
    };

    /* Fecha o modal de visualização da foto */
    handleCloseImageModal = () => {
        setTimeout(() => {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }, 10);

        this.setState({
            isImageModalOpen: false,
            imageModalSrc: '',
            imageModalAlt: ''
        });
    };

    /* Abre o modal de observação */
    handleOpenObsModal = (item) => {
        this.setState({
            openObsModal: true,
            obsModalTexto: item && item.obs ? item.obs : '',
            obsModalTitulo: item && item.coditemos ? `Observação OS ${item.nroos}` : 'Observação'
        });
    };

    /* Fecha o modal de observação */
    handleCloseObsModal = () => {
        this.setState({
            openObsModal: false,
            obsModalTexto: '',
            obsModalTitulo: ''
        });
    };

    /* Agrupa os itens por hotel */
    groupByHotel = (itens) => {
        const groups = {};

        (itens || []).forEach((item) => {
            const hotel = item.hotel || 'SEM HOTEL';

            if (!groups[hotel]) {
                groups[hotel] = [];
            }

            groups[hotel].push(item);
        });

        return groups;
    };

    /* Retorna a rota base */
    getBaseRoute = () => {
        const { match } = this.props;

        return match.path.startsWith('/admpartner')
            ? '/admpartner/agendaescalafornecedor'
            : '/partner/agendaescalafornecedor';
    };

    /* Abre o modal de passageiros */
    handleOpenPaxModal = async (item = null) => {
        const { escala } = this.state;

        try {
            const params = item ? `?coditemos=${item.coditemos}` : '';
            const response = await api.get(`/agendaescalafornecedor/${escala.coditemescala}/pax${params}`);
            const paxModalItens = getResponseData(response);

            this.setState({
                openPaxModal: true,
                paxModalItens,
                paxModalTotal: item ? item.totalpax : escala.totalpax,
                paxModalTitulo: item ? `OS ${item.nroos} - ${item.titular}` : `Escala ${escala.coditemescala}`,
                paxModalGeral: !item
            });
        } catch (error) {
            console.error(
                'Erro ao carregar passageiros:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar passageiros!'
                )
            );
        }
    };

    /* Fecha o modal de passageiros */
    handleClosePaxModal = () => {
        this.setState({
            openPaxModal: false,
            paxModalTitulo: '',
            paxModalTotal: 0,
            paxModalItens: [],
            paxModalGeral: false
        });
    };

    /* Agrupa os passageiros por OS */
    groupPaxByOS = (paxModalItens) => {
        const groups = {};

        (paxModalItens || []).forEach((pax) => {
            const key = pax.coditemos || pax.nroos;

            if (!groups[key]) {
                groups[key] = {
                    coditemos: pax.coditemos,
                    nroos: pax.nroos,
                    titular: pax.titular,
                    itens: []
                };
            }

            groups[key].itens.push(pax);
        });

        return Object.values(groups);
    };

    /* Retorna o handler de hover de entrada */
    handleObsIconMouseEnter = (semObs) => (event) => {
        handleEnabledIconMouseEnter(event, semObs);
    };

    /* Retorna o handler de hover de saída */
    handleObsIconMouseLeave = (semObs) => (event) => {
        handleEnabledIconMouseLeave(event, semObs);
    };

    /* Renderiza o ícone de observação da OS */
    renderObsIcon = (item) => {
        const semObs = !item.obs || item.obs.trim() === '';

        return (
            <Tooltip title={semObs ? '' : 'Observação'}>
                <span>
                    <FeedbackOutlined
                        onMouseEnter={this.handleObsIconMouseEnter(semObs)}
                        onMouseLeave={this.handleObsIconMouseLeave(semObs)}
                        onClick={() => this.handleObsIconClick(item, semObs)}
                        style={{
                            cursor: semObs ? 'default' : 'pointer',
                            color: semObs ? theme.palette.grey[400] : theme.palette.primary.main
                        }}
                    />
                </span>
            </Tooltip>
        );
    };

    /* Retorna o handler de hover de entrada */
    handleFotoKmIconMouseEnter = (disabled) => (event) => {
        if (!disabled) {
            event.currentTarget.style.color = theme.palette.secondary.main;
        }
    };
    /* Retorna o handler de hover de saída */
    handleFotoKmIconMouseLeave = (disabled, hasImage) => (event) => {
        if (!disabled) {
            event.currentTarget.style.color = hasImage
                ? theme.palette.success.main : theme.palette.primary.main;
        }
    };

    /* Retorna o handler de clique do ícone Cloud (view) */
    handleFotoKmIconClick = (isView, imageSrc, imageAlt) => (event) => {
        if (!isView) {
            return;
        }

        event.preventDefault();

        this.handleFotoKmIconMouseLeave(isView && !imageSrc, !!imageSrc)(event);
        this.handleOpenImageModal(imageSrc, imageAlt);
    };

    /* Renderiza o campo de foto do KM */
    renderFotoKmField = ({
        fileName,
        imageSrc,
        imageAlt
    }) => {
        const { isView } = this.state;

        return (
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
            >
                <Tooltip title={isView ? imageAlt : `Inserir ${imageAlt.toLowerCase()}`}>
                    <label>
                        <CloudUploadOutlined
                            onClick={this.handleFotoKmIconClick(isView, imageSrc, imageAlt)}
                            onMouseEnter={this.handleFotoKmIconMouseEnter(isView && !imageSrc)}
                            onMouseLeave={this.handleFotoKmIconMouseLeave(isView && !imageSrc, !!imageSrc)}
                            style={{
                                cursor: isView && !imageSrc ? 'default' : 'pointer',
                                fontSize: 26,
                                color: isView && !imageSrc ? theme.palette.grey[400] : imageSrc
                                    ? theme.palette.success.main : theme.palette.primary.main
                            }}
                        />

                        {!isView && (
                            <input
                                type="file"
                                name={fileName}
                                accept="image/*"
                                hidden
                                onChange={this.handleFotoChange}
                            />
                        )}
                    </label>
                </Tooltip>

                <Button
                    variant={imageSrc ? 'contained' : 'outlined'}
                    size="small"
                    disabled={!imageSrc}
                    onClick={() => this.handleOpenImageModal(imageSrc, imageAlt)}
                    style={imageSrc ? {
                        backgroundColor: theme.palette.success.main,
                        color: theme.palette.common.white
                    } : undefined}
                >
                    Visualizar
                </Button>
            </Box>
        );
    };

    render() {
        const {
            configPartner,
            escala,
            fotoKmFinalPreview,
            fotoKmInicialPreview,
            imageModalAlt,
            imageModalSrc,
            isGeneratingReport,
            isImageModalOpen,
            isLoading,
            isView,
            itens,
            kmfinal,
            kminicial,
            messageAlert,
            obsModalTexto,
            obsModalTitulo,
            openAlert,
            openObsModal,
            openPaxModal,
            paxModalItens,
            paxModalGeral,
            paxModalTitulo,
            paxModalTotal
        } = this.state;

        if (isLoading) {
            return (
                <div style={{ padding: 30 }}>
                    <Typography variant="body1">
                        Carregando...
                    </Typography>
                </div>
            );
        }

        if (!escala) {
            return (
                <div style={{ padding: 30 }}>
                    <Typography variant="body1">
                        Não foi possível carregar os dados da escala.
                    </Typography>

                    <br />

                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={this.onClickVoltar}
                    >
                        Voltar
                    </Button>

                    <AlertInformation
                        open={openAlert}
                        message={messageAlert}
                        handleClose={this.handleCloseAlert}
                    />
                </div>
            );
        }

        const grupos = this.groupByHotel(itens);
        const hoteisOrdenados = Object.keys(grupos).sort((a, b) => a.localeCompare(b));

        const fotoKmInicialSrc = fotoKmInicialPreview || (
            escala?.fotokminicial ? `data:image/jpeg;base64,${escala.fotokminicial}` : ''
        );

        const fotoKmFinalSrc = fotoKmFinalPreview || (
            escala?.fotokmfinal ? `data:image/jpeg;base64,${escala.fotokmfinal}` : ''
        );

        const gruposPax = this.groupPaxByOS(paxModalItens);

        const informaKmIniFim = isFlagAtiva(configPartner, 'informakminifim');
        const registraFotoKm = isFlagAtiva(configPartner, 'registrafotokm');
        const informaDataHoraFinal = isFlagAtiva(configPartner, 'informadatahsfinal');
        const baixaRelEscTransp = isFlagAtiva(configPartner, 'baixarelesctransp');

        return (
            <div
                style={{
                    marginLeft: 30,
                    marginTop: 30,
                    marginRight: 30
                }}
            >
                <Card>
                    <CardContent>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            style={{
                                flexWrap: 'wrap',
                                gap: 12
                            }}
                        >
                            <Typography variant="h5">
                                Escala {escala.coditemescala}
                            </Typography>

                            <Box
                                display="flex"
                                alignItems="center"
                                flexWrap="wrap"
                                style={{ gap: 10 }}
                            >
                                {baixaRelEscTransp && (
                                    <Tooltip title={isGeneratingReport ? 'Gerando relatório...' : 'Baixar relatório'}>
                                        <PictureAsPdfRounded
                                            onClick={this.onClickGenerateReport}
                                            onMouseEnter={this.handleReportIconMouseEnter}
                                            onMouseLeave={this.handleReportIconMouseLeave}
                                            style={{
                                                cursor: isGeneratingReport ? 'not-allowed' : 'pointer',
                                                color: isGeneratingReport ? theme.palette.grey[500] : theme.palette.primary.main,
                                                fontSize: 26,
                                                opacity: isGeneratingReport ? 0.7 : 1,
                                                pointerEvents: isGeneratingReport ? 'none' : 'auto'
                                            }}
                                        />
                                    </Tooltip>
                                )}

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.onClickVoltar}
                                >
                                    Voltar
                                </Button>

                                {!isView && (informaKmIniFim || registraFotoKm) && (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.onClickSave}
                                    >
                                        Salvar
                                    </Button>
                                )}
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                marginTop: 12,
                                marginBottom: 12
                            }}
                        />

                        <Box
                            display="flex"
                            justifyContent="space-between"
                            style={{
                                flexWrap: 'wrap',
                                gap: 24
                            }}
                        >
                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="flex-start"
                                justifyContent="space-between"
                                style={{
                                    gap: 12,
                                    minHeight: 82
                                }}
                            >
                                <Box style={{ textAlign: 'left' }}>
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Data
                                    </Typography>

                                    <Typography variant="body1">
                                        {formatData(escala.dataservico)}
                                    </Typography>
                                </Box>

                                <Box style={{ textAlign: 'left' }}>
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Serviço
                                    </Typography>

                                    <Typography variant="body1">
                                        {escala.descservico}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                display="flex"
                                flexDirection="column"
                                alignItems="flex-end"
                                justifyContent="space-between"
                                style={{
                                    gap: 12,
                                    minHeight: 82
                                }}
                            >
                                <Box style={{ textAlign: 'right' }}>
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Total Pax
                                    </Typography>

                                    <Typography variant="body1">
                                        <span
                                            onClick={() => this.handleOpenPaxModal()}
                                            style={{
                                                cursor: 'pointer',
                                                color: theme.palette.primary.main,
                                                fontWeight: 500
                                            }}
                                        >
                                            {escala.totalpax}
                                        </span>
                                    </Typography>
                                </Box>

                                <Box style={{ textAlign: 'right' }}>
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                    >
                                        Hora Serviço
                                    </Typography>

                                    <Typography variant="body1">
                                        {formatTime(escala.horaservico)}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                        <Divider
                            style={{
                                marginTop: 8,
                                marginBottom: 12
                            }}
                        />

                        {/* Bloco de configurações do módulo partner */}
                        {(informaKmIniFim || registraFotoKm || informaDataHoraFinal) && (
                            <React.Fragment>
                                <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    style={{
                                        flexWrap: 'wrap',
                                        gap: 24
                                    }}
                                >
                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        style={{ gap: 12 }}
                                    >
                                        {informaKmIniFim && (
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="flex-end"
                                                style={{ gap: 8 }}
                                            >
                                                <TextField
                                                    label="KM inicial"
                                                    name="kminicial"
                                                    value={kminicial}
                                                    onChange={this.handleKmChange}
                                                    disabled={isView}
                                                    variant="outlined"
                                                    inputProps={{
                                                        inputMode: 'numeric',
                                                        pattern: '[0-9]*',
                                                        maxLength: 10
                                                    }}
                                                    style={{
                                                        minWidth: 120,
                                                        flex: '0 1 120px',
                                                        backgroundColor: isView ? theme.palette.grey[100] : 'transparent'
                                                    }}
                                                />

                                                {registraFotoKm && this.renderFotoKmField({
                                                    fileName: 'fotoKmInicial',
                                                    imageSrc: fotoKmInicialSrc,
                                                    imageAlt: 'Foto KM inicial'
                                                })}
                                            </Box>
                                        )}

                                        {informaKmIniFim && (
                                            <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="flex-end"
                                                style={{ gap: 8 }}
                                            >
                                                <TextField
                                                    label="KM final"
                                                    name="kmfinal"
                                                    value={kmfinal}
                                                    onChange={this.handleKmChange}
                                                    disabled={isView}
                                                    variant="outlined"
                                                    inputProps={{
                                                        inputMode: 'numeric',
                                                        pattern: '[0-9]*',
                                                        maxLength: 10
                                                    }}
                                                    style={{
                                                        minWidth: 120,
                                                        flex: '0 1 120px',
                                                        backgroundColor: isView ? theme.palette.grey[100] : 'transparent'
                                                    }}
                                                />

                                                {registraFotoKm && this.renderFotoKmField({
                                                    fileName: 'fotoKmFinal',
                                                    imageSrc: fotoKmFinalSrc,
                                                    imageAlt: 'Foto KM final'
                                                })}
                                            </Box>
                                        )}
                                    </Box>

                                    <Box
                                        display="flex"
                                        flexDirection="column"
                                        justifyContent="space-between"
                                        style={{
                                            gap: 12,
                                            minHeight: 116
                                        }}
                                    >
                                        {informaDataHoraFinal && (
                                            <TextField
                                                label="Data final serviço"
                                                type="date"
                                                value={getDateInputValue(escala?.datafimservico)}
                                                variant="outlined"
                                                disabled
                                                InputLabelProps={{ shrink: true }}
                                                style={{ width: 150 }}
                                            />
                                        )}

                                        {informaDataHoraFinal && (
                                            <TextField
                                                label="Hora final serviço"
                                                type="time"
                                                value={formatTime(escala?.horafimservico)}
                                                variant="outlined"
                                                disabled
                                                InputLabelProps={{ shrink: true }}
                                                style={{ width: 150 }}
                                            />
                                        )}
                                    </Box>
                                </Box>

                                <br />

                                <Divider
                                    style={{
                                        marginTop: 8,
                                        marginBottom: 12
                                    }}
                                />
                            </React.Fragment>
                        )}

                        <Typography variant="h6">
                            Ordens de Serviço Escaladas
                        </Typography>

                        <br />

                        {hoteisOrdenados.length === 0 ? (
                            <Typography variant="body2">
                                Nenhuma OS encontrada para essa escala
                            </Typography>
                        ) : (
                            hoteisOrdenados.map((hotel) => (
                                <Box
                                    key={hotel}
                                    style={{ marginBottom: 18 }}
                                >
                                    <Paper>
                                        <PerfectScrollBar>
                                            <div style={{ minWidth: 1200 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center">
                                                                OS
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Titular
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Total Pax
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Hotel
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Local Origem
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Local Destino
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Hora Apresentação
                                                            </TableCell>

                                                            <TableCell align="center">
                                                                Observação
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>

                                                    <TableBody>
                                                        {grupos[hotel].map((item) => (
                                                            <TableRow
                                                                hover
                                                                key={item.nroos}
                                                            >
                                                                <TableCell align="center">
                                                                    {item.nroos}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.titular}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    <span
                                                                        onClick={() => this.handleOpenPaxModal(item)}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            color: theme.palette.primary.main,
                                                                            fontWeight: 500
                                                                        }}
                                                                    >
                                                                        {item.totalpax}
                                                                    </span>
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.hotel}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.localorigem}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {item.localdestino}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {formatTime(item.horaapresentacao)}
                                                                </TableCell>

                                                                <TableCell align="center">
                                                                    {this.renderObsIcon(item)}
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>
                                        </PerfectScrollBar>
                                    </Paper>
                                </Box>
                            ))
                        )}
                    </CardContent>
                </Card>

                <Dialog
                    open={openObsModal}
                    onClose={this.handleCloseObsModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        {obsModalTitulo}
                    </DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        <FormGroup style={{ marginBottom: 8 }}>
                            <textarea
                                value={obsModalTexto}
                                readOnly
                                style={{
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    height: 220,
                                    padding: 12,
                                    border: `1px solid ${theme.palette.grey[400]}`,
                                    borderRadius: 6,
                                    fontFamily: 'Calibri, sans-serif',
                                    resize: 'none',
                                    overflowY: 'auto',
                                    cursor: 'default'
                                }}
                            />
                        </FormGroup>
                    </DialogContent>
                </Dialog>

                <ImagePreviewModal
                    open={isImageModalOpen}
                    src={imageModalSrc}
                    alt={imageModalAlt}
                    onClose={this.handleCloseImageModal}
                />

                <Dialog
                    open={openPaxModal}
                    onClose={this.handleClosePaxModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        <span style={{ color: paxModalGeral ? theme.palette.common.black : theme.palette.primary.main }}>
                            {paxModalTitulo} - Total Pax:{' '}
                            {paxModalTotal}
                        </span>
                    </DialogTitle>

                    <DialogContent style={{ paddingBottom: 24 }}>
                        {paxModalItens.length === 0 && (
                            <Typography
                                variant="body2"
                                align="center"
                            >
                                Nenhum passageiro encontrado
                            </Typography>
                        )}

                        {paxModalGeral ? (
                            gruposPax.map((grupo) => (
                                <Box
                                    key={grupo.coditemos || grupo.nroos}
                                    style={{ marginBottom: 24 }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            color: theme.palette.primary.main,
                                            fontWeight: 500,
                                            marginBottom: 8
                                        }}
                                    >
                                        OS {grupo.nroos} -{' '}
                                        {grupo.titular} - Total Pax:{' '}
                                        {grupo.itens.length}
                                    </Typography>

                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Passageiro
                                                </TableCell>

                                                <TableCell align="center">
                                                    Tipo
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {grupo.itens.map((pax, index) => (
                                                <TableRow key={`${pax.coditemos}-${index}`}>
                                                    <TableCell>
                                                        {pax.nome}
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        {pax.tipo}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </Box>
                            ))
                        ) : (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            Passageiro
                                        </TableCell>

                                        <TableCell align="center">
                                            Tipo
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {paxModalItens.map((pax, index) => (
                                        <TableRow key={`${pax.coditemos}-${index}`}>
                                            <TableCell>
                                                {pax.nome}
                                            </TableCell>

                                            <TableCell align="center">
                                                {pax.tipo}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                    </DialogContent>
                </Dialog>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />
            </div >
        );
    }
};

AgendaEscalaFornecedorForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object
};

export default AgendaEscalaFornecedorForm;